/**
 * MetaSrt (subset) — aligned's `meta_srts` collection. Only the fields the
 * expert-side partner-access screen reads are modelled here; admin-side
 * flows (create/assign) belong with the admin port.
 *
 * `srtSetupCompleted` and `proxyConfigured` are nullable-boolean upstream
 * (aligned uses `bool?` — not-yet-set is distinct from `false`); we preserve
 * that so the derivation can distinguish.
 */

export interface MetaSrt {
  id: string;
  firebaseId: string | null;
  expertId: string | null;
  expertName: string | null;
  expertEmail: string | null;
  cloudFlareDestinationEmailSet: boolean;
  cloudFlareSetupCompleted: boolean;
  srtEmail: string | null;
  srtSetupCompleted: boolean | null;
  srtId: string | null;
  proxyConfigured: boolean | null;
  createdAt: string | null;
  deletedAt: string | null;
}

type Data = Record<string, unknown>;

const strOrNull = (v: unknown): string | null => (typeof v === 'string' ? v : null);
const bool = (v: unknown, dflt: boolean): boolean => (typeof v === 'boolean' ? v : dflt);
const boolOrNull = (v: unknown): boolean | null => (typeof v === 'boolean' ? v : null);

export function mapMetaSrt(id: string, data: Data): MetaSrt {
  return {
    id,
    firebaseId: strOrNull(data.firebaseId),
    expertId: strOrNull(data.expertId),
    expertName: strOrNull(data.expertName),
    expertEmail: strOrNull(data.expertEmail),
    cloudFlareDestinationEmailSet: bool(data.cloudFlareDestinationEmailSet, false),
    cloudFlareSetupCompleted: bool(data.cloudFlareSetupCompleted, false),
    srtEmail: strOrNull(data.srtEmail),
    srtSetupCompleted: boolOrNull(data.srtSetupCompleted),
    srtId: strOrNull(data.srtId),
    proxyConfigured: boolOrNull(data.proxyConfigured),
    createdAt: strOrNull(data.createdAt),
    deletedAt: strOrNull(data.deletedAt),
  };
}
